// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Favorite: React.FC = () => {
    return <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="3.-Style" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="1.Iconography" transform="translate(-324.000000, -237.000000)" fill="currentColor">
            <g transform="translate(79.000000, 230.000000)">
                <g transform="translate(245.000000, 7.000000)">
                    <path d="M8.10901699,12.25625 L3.60901699,15.45625 C3.40901699,15.55625 3.10901699,15.45625 3.20901699,15.15625 L4.70901699,10.05625 L0.109016994,6.85625 C-0.0909830056,6.65625 0.00901699437,6.35625 0.209016994,6.35625 L5.70901699,5.85625 L7.70901699,0.65625 C7.80901699,0.45625 8.10901699,0.45625 8.20901699,0.65625 L10.209017,5.85625 L15.709017,6.35625 C15.909017,6.35625 16.009017,6.65625 15.809017,6.75625 L11.309017,10.05625 L12.809017,15.15625 C12.909017,15.35625 12.609017,15.55625 12.409017,15.45625 L8.10901699,12.25625 L8.10901699,12.25625 Z"></path>
                </g>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(Favorite);
